import React, { useState } from 'react';
import { Button } from './ui/button';
import { Search, Menu, X, ShoppingBag } from 'lucide-react';
import { categories } from '../data/mockData';

const Header = ({ onMenuClick }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    // Handle search functionality
    console.log('Searching for:', searchTerm);
  };

  return (
    <>
      {/* Top Banner */}
      <div className="bg-green-600 text-white text-center py-2 text-sm">
        <div className="container mx-auto px-4">
          🔥 Text (945) 545-7553 to Place Orders • Premium Cannabis • Dallas Delivery
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-black border-b border-gray-800 sticky top-0 z-40">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_f6290634-86b4-4bd7-80d7-4011d06242d9/artifacts/mvt79ma9_29A81CA4-6157-450E-BDCF-09CA0369D517.png"
                alt="Big Dog Kush" 
                className="h-12 w-auto filter brightness-0 invert"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#" className="text-gray-300 hover:text-green-400 font-medium transition-colors">
                Shop Menu
              </a>
              <div className="relative group">
                <button className="text-gray-300 hover:text-green-400 font-medium transition-colors flex items-center">
                  Explore Strains
                </button>
              </div>
              <a href="#" className="text-gray-300 hover:text-green-400 font-medium transition-colors">
                Weekly Deals
              </a>
              <a href="#" className="text-gray-300 hover:text-green-400 font-medium transition-colors">
                Contact
              </a>
            </nav>

            {/* Search & Actions */}
            <div className="flex items-center space-x-4">
              {/* Search */}
              <div className={`flex items-center transition-all duration-300 ${isSearchOpen ? 'w-64' : 'w-auto'}`}>
                {isSearchOpen ? (
                  <form onSubmit={handleSearch} className="flex items-center w-full">
                    <input
                      type="text"
                      placeholder="Search strains..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full px-4 py-2 bg-gray-800 border border-gray-600 rounded-l-lg focus:outline-none focus:border-green-500 text-white placeholder-gray-400"
                      autoFocus
                    />
                    <Button type="submit" className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded-r-lg">
                      <Search size={20} />
                    </Button>
                    <Button 
                      type="button"
                      variant="ghost"
                      onClick={() => setIsSearchOpen(false)}
                      className="ml-2 text-gray-400 hover:text-white"
                    >
                      <X size={20} />
                    </Button>
                  </form>
                ) : (
                  <Button 
                    variant="ghost" 
                    onClick={() => setIsSearchOpen(true)}
                    className="hidden md:flex text-gray-400 hover:text-green-400"
                  >
                    <Search size={20} />
                  </Button>
                )}
              </div>

              {/* Call/Text Now Button */}
              <Button 
                onClick={() => window.location.href = 'tel:+19455457553'}
                className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 hidden sm:flex"
              >
                Text Now
              </Button>

              {/* Mobile Menu Button */}
              <Button
                variant="ghost"
                className="md:hidden text-gray-400 hover:text-white"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </Button>
            </div>
          </div>

          {/* Product Categories Bar */}
          <div className="hidden md:flex items-center space-x-6 py-3 border-t border-gray-800">
            {categories.slice(0, 7).map((category) => (
              <button
                key={category.id}
                onClick={() => onMenuClick && onMenuClick(category.slug)}
                className="text-sm text-gray-400 hover:text-green-400 font-medium transition-colors uppercase tracking-wide"
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black border-t border-gray-800">
            <div className="px-4 py-4 space-y-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search strains..."
                  className="w-full px-4 py-2 bg-gray-800 border border-gray-600 rounded-lg focus:outline-none focus:border-green-500 text-white placeholder-gray-400"
                />
                <Search className="absolute right-3 top-2.5 text-gray-400" size={20} />
              </div>
              
              <nav className="space-y-2">
                <a href="#" className="block py-2 text-gray-300 font-medium hover:text-green-400">Shop Menu</a>
                <a href="#" className="block py-2 text-gray-300 font-medium hover:text-green-400">Explore Strains</a>
                <a href="#" className="block py-2 text-gray-300 font-medium hover:text-green-400">Weekly Deals</a>
                <a href="#" className="block py-2 text-gray-300 font-medium hover:text-green-400">Contact</a>
              </nav>
              
              <div className="border-t border-gray-800 pt-4">
                <div className="grid grid-cols-2 gap-2">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => {
                        onMenuClick && onMenuClick(category.slug);
                        setIsMobileMenuOpen(false);
                      }}
                      className="text-sm text-gray-400 hover:text-green-400 py-2 text-left"
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
                
                <div className="mt-4 pt-4 border-t border-gray-800">
                  <Button 
                    onClick={() => window.location.href = 'sms:+19455457553?body=' + encodeURIComponent('Hi! I want to place an order with Big Dog Kush. Can you help me?')}
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-medium"
                  >
                    Text (945) 545-7553
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;